/*
loading: false,
        responseBody: (action.type) ? action : action.payload.error,
        error: action.payload.message,
        errorObject:action.payload


          var items = (Array.isArray(a[idx])) ? a[idx] : [a[idx]];
                        items.map((item) => {
                            if (idx == "network"){item.Dashboard = [];item.networkConnections = {}}
                            item.generic = a[idx];
                            item.generic.subTitle = item.generic.name;
                        var label = a.account.charAt(0).toUpperCase() + a.account.slice(1);
                        item.accountType = label;
                        accs[label] = accs[label] ? accs[label] : [];
                        accs[label].push(item);
                        this[label] = (this[label]) ? this[label] : [];
                        this[label].push(item);
                        });
        */








class Accounts{
    constructor(params) {
         this.user_accounts = params.user_accounts;
         this.user_email = params.user_email;
         this.access = params.access;
         this.userDocumentId = params.documentId;
         this.access = params.access ? params.access : [];
         this.generic = {
            name:"",
            subTitle:"",
            accountType:"",
            img:"",
            label:"",
            id:"",
            platformId:"",
            model:""
         };
         this.Metric = [];
        }

         setName(val){
        this.name = val;
        this.generic.name = val;
        this.generic.subTitle = val;
    }
     setPlatformId(val){
        this.platformId = val;
        this.generic.id = val;
    }

        
    setDocumentId(val){
        this.id = val;
        this.documentId = val;
        this.generic.id = val;
    }
  }
export default Accounts;
          